export default {
    setLoading({ commit }, payload){
        commit('setLoading', payload)
    },

    setAlert({ commit }, payload){
        commit('setAlert', payload)
    }
}
